import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import Modal from 'react-modal';

import successIcon from '../assets/icon/success_zhuce_icon@3x.png';

const overlayStyle = {
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  top: '0px',
};

const contentStyle = {
  top: '30%',
  left: '115px',
  right: '115px',
  bottom: 'auto',
  padding: '0',
  backgroundColor: 'white',
  border: 'none',
  borderRadius: '5px',
};

const ModalContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 40px 30px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: start;
  align-items: center;  
`;

ModalContent.Icon = styled.div`
  margin: ${70 - 40}px 0 50px 0;
  width: 120px;
  height: 120px;
  background-image: url(${successIcon});
  background-size: cover;
`;

ModalContent.Title = styled.h1`
  font-size: 42px;
  color: rgb(34, 167, 240);
  line-height: 1;
  margin: 0;
  margin-bottom: 34px;
`;

class SuccessModal extends React.Component {
  render() {
    const {
      isOpen, title, children, onRequestClose
    } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={() => onRequestClose()}
        contentLabel='Success'
        style={{ overlay: overlayStyle, content: contentStyle }}
        parentSelector={() => document.querySelector('#root')}
      >
        <ModalContent>
          <ModalContent.Icon />
          <ModalContent.Title>{title}</ModalContent.Title>
          { children }
        </ModalContent>
      </Modal>
    );
  }
}

SuccessModal.defaultProps = {
  children: null,
  onRequestClose: () => null,
};

SuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  onRequestClose: PropTypes.func,
};

export default SuccessModal;



// WEBPACK FOOTER //
// ./src/components/success-modal.jsx